// BDEHeader.tsx

import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { employeeDetails } from '../../config/pageConfig'; 
interface Props {
  employee: any;
}

const BDEHeader: React.FC<Props> = ({ employee }) => {
  if (!employee) return null;
  return (
    <div className="border border-blue-400 p-4 rounded-lg bg-white shadow-sm flex items-start space-x-4 mb-6">
      <div className="flex-shrink-0">
        <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center">
          <UserOutlined className="text-2xl text-gray-500" />
        </div>
      </div>

      <div className="flex-grow">
        <h2 className="text-xl font-semibold text-gray-800">
          {employee.firstName} {employee.lastName}
        </h2>

        <p className="text-sm text-gray-600">
          {employee.jobTitles?.name || '—'}
        </p>

        <div className="flex text-sm text-gray-500 mt-1 space-x-4">
          <span>{employee.location || '—'}</span>
          <span className="text-gray-400">|</span>
          <span>{employee.workEmail}</span>
          <span className="text-gray-400">|</span>
          <span>{employee.mobile}</span>
        </div>
      </div>

      <div className="flex-shrink-0 self-center">
        <span className="inline-block px-3 py-1 text-sm font-medium text-green-700 bg-green-200 rounded-full">
          {employee.status}
        </span>
      </div>
    </div>
  );
};

export default BDEHeader;